<template>
    <div>
        <h2>First Setup</h2>
        <p>Welcome to the first setup!</p>
        <p>The following pages will guide you through the configuration to start using you service.</p>
    </div>
</template>

<script>
export default {
  name: 'SetupFirstPage'
}
</script>

<style scoped>
h2 {
  font-weight: normal;
}
</style>
